import _definePage_default_0 from '/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/forgot-password.vue?definePage&vue'
import _definePage_default_3 from '/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/invite/[code].vue?definePage&vue'
import _definePage_default_4 from '/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_5 from '/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/not-authorized.vue?definePage&vue'
import _definePage_default_6 from '/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/register.vue?definePage&vue'
import _definePage_default_7 from '/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/signup.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/admin',
    /* internal name: 'admin' */
    /* no component */
    children: [
      {
        path: '',
        name: 'admin',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/index.vue'),
        /* no children */
      },
      {
        path: 'analytics',
        name: 'admin-analytics',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/analytics.vue'),
        /* no children */
      },
      {
        path: 'audit-log',
        name: 'admin-audit-log',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/audit-log.vue'),
        /* no children */
      },
      {
        path: 'banners',
        name: 'admin-banners',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/banners.vue'),
        /* no children */
      },
      {
        path: 'billing',
        /* internal name: 'admin-billing' */
        /* no component */
        children: [
          {
            path: 'discounts',
            name: 'admin-billing-discounts',
            component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/billing/discounts.vue'),
            /* no children */
          },
          {
            path: 'revenue',
            name: 'admin-billing-revenue',
            component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/billing/revenue.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'broadcast-history',
        name: 'admin-broadcast-history',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/broadcast-history.vue'),
        /* no children */
      },
      {
        path: 'communications',
        name: 'admin-communications',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/communications.vue'),
        /* no children */
      },
      {
        path: 'customers-stores',
        name: 'admin-customers-stores',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/customers-stores.vue'),
        /* no children */
      },
      {
        path: 'data-issues',
        name: 'admin-data-issues',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/data-issues.vue'),
        /* no children */
      },
      {
        path: 'dcg-exceptions',
        name: 'admin-dcg-exceptions',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/dcg-exceptions.vue'),
        /* no children */
      },
      {
        path: 'hardware-management',
        name: 'admin-hardware-management',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/hardware-management.vue'),
        /* no children */
      },
      {
        path: 'identity-search',
        name: 'admin-identity-search',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/identity-search.vue'),
        /* no children */
      },
      {
        path: 'location-exceptions',
        name: 'admin-location-exceptions',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/location-exceptions.vue'),
        /* no children */
      },
      {
        path: 'module-activity',
        name: 'admin-module-activity',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/module-activity.vue'),
        /* no children */
      },
      {
        path: 'modules',
        /* internal name: 'admin-modules' */
        /* no component */
        children: [
          {
            path: ':customerNumber',
            name: 'admin-modules-customer-number',
            component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/modules/[customerNumber].vue'),
            children: [
              {
                path: ':storeID-:moduleID',
                name: 'admin-modules-customer-number-store-idmodule-id',
                component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/modules/[customerNumber]/[storeID]-[moduleID].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'modules-billing',
        name: 'admin-modules-billing',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/modules-billing.vue'),
        /* no children */
      },
      {
        path: 'onboarding-analytics',
        name: 'admin-onboarding-analytics',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/onboarding-analytics.vue'),
        /* no children */
      },
      {
        path: 'operations',
        name: 'admin-operations',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/operations.vue'),
        /* no children */
      },
      {
        path: 'purchases',
        name: 'admin-purchases',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/purchases.vue'),
        /* no children */
      },
      {
        path: 'settings',
        name: 'admin-settings',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/settings.vue'),
        /* no children */
      },
      {
        path: 'stores',
        name: 'admin-stores',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/stores.vue'),
        /* no children */
      },
      {
        path: 'tour-steps',
        name: 'admin-tour-steps',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/tour-steps.vue'),
        /* no children */
      },
      {
        path: 'user-directory',
        name: 'admin-user-directory',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/user-directory.vue'),
        /* no children */
      },
      {
        path: 'users',
        name: 'admin-users',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/users.vue'),
        /* no children */
      },
      {
        path: 'users-access',
        name: 'admin-users-access',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/admin/users-access.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/control-center',
    /* internal name: 'control-center' */
    /* no component */
    children: [
      {
        path: 'organizations',
        name: 'control-center-organizations',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/control-center/organizations.vue'),
        /* no children */
      },
      {
        path: 'platform-invites',
        name: 'control-center-platform-invites',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/control-center/platform-invites.vue'),
        /* no children */
      },
      {
        path: 'roles-permissions',
        name: 'control-center-roles-permissions',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/control-center/roles-permissions.vue'),
        /* no children */
      },
      {
        path: 'store-details',
        name: 'control-center-store-details',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/control-center/store-details.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/edit-profile',
    name: 'edit-profile',
    component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/edit-profile.vue'),
    /* no children */
  },
  {
    path: '/equipment',
    name: 'equipment',
    component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/equipment.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/home',
    name: 'home',
    component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/home.vue'),
    /* no children */
  },
  {
    path: '/insights-equipment-management',
    name: 'insights-equipment-management',
    component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/insights-equipment-management.vue'),
    /* no children */
  },
  {
    path: '/invite',
    /* internal name: 'invite' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':code',
        name: 'invite-code',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/invite/[code].vue'),
        /* no children */
      },
  _definePage_default_3
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_4
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_5
  ),
  _mergeRouteRecord(
  {
    path: '/register',
    name: 'register',
    component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/register.vue'),
    /* no children */
  },
  _definePage_default_6
  ),
  _mergeRouteRecord(
  {
    path: '/signup',
    name: 'signup',
    component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/signup.vue'),
    /* no children */
  },
  _definePage_default_7
  ),
  {
    path: '/subscriptions',
    /* internal name: 'subscriptions' */
    /* no component */
    children: [
      {
        path: '',
        name: 'subscriptions',
        component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/subscriptions/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/waste-tracking',
    name: 'waste-tracking',
    component: () => import('/home/runner/work/EatSuite2/EatSuite2/resources/js/pages/waste-tracking.vue'),
    /* no children */
  }
]
